import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'
import {UserAvatar} from '../../../../app/components/UserAvatar'

const itemClass = 'ms-1 ms-lg-3'

const Navbar = () => {
  const {currentUser} = useAuth()
  
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className='cursor-pointer'
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <UserAvatar
            firstName={currentUser?.nombre ?? currentUser?.first_name}
            lastName={currentUser?.apellido ?? currentUser?.last_name}
            email={currentUser?.email}
            size='sm'
          />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
